import{a as t}from"./chunk-5BJ27XU6.js";import{h as o}from"./chunk-F4DBBFBM.js";import{m as e}from"./chunk-HBP5N4FR.js";e();import p from"swr";function O(){let c=n=>t(n).then(m=>m.data),{data:r,error:i}=p(o,c);return{price:r==null?void 0:r.price,error:i}}export{O as a};
//# sourceMappingURL=chunk-BPUQDGHW.js.map
